import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { PassengersReportService } from '../../services/passengers-report.service';
import { CommonService } from '../../services/common.service';
import { UserService } from '../../services/user.service';
import swal from 'sweetalert2';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  plates: any = [];
  user_account: any;
  imeiVei: any = {};
  userById: any= {};
  FOLDER = 'passengerControl/';
  accessKey = 'AKIAJBSEKUWJ6JUFUTIA';
  secretKey = '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';
  bucketName = 'upload';
  imgName= '';
  driverImg: any = null;
  isSubmitted_1: any = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private passengersReportService: PassengersReportService,
    private commonService: CommonService,
    private userService: UserService,
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser(): void {
    this.route.paramMap.switchMap((params: ParamMap) => this.userService.getUser(params.get('idUser')))
      .subscribe(response => {
        if (response.length > 0) {
          this.userById.Identification = response[0].identification;
          this.userById.Name = response[0].name;
          this.userById.Email = response[0].email;     
          this.userById.Password = response[0].password;
          this.userById.User_account = response[0].user_account;
          this.userById.Id = response[0].id;     
          this.userById.Status = response[0].status;          
        }
      });
  }

  

  sendMail(): void {
    this.userService.sendMail(this.userById).then(response => {
       debugger;
    });
  }

  saveUser(): void {
    console.log('this.commonService.getUserName() ; ', this.commonService.getUserName())
    let that = this
    this.userById.User_account = this.commonService.getUserName();
    this.userService.saveUser(this.userById)
      .then(obj => {
        const response = JSON.parse(obj.toString());
        if (response) {
          console.log('response : ', response)
          this.router.navigate(['/home/users']);
          if (response.status === 'EXITO') {
            swal({
              title: response.message,
              text: '',
              type: 'success',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#ff5370',
              confirmButtonText: 'Volver',
              // cancelButtonText: 'No'
            }).catch(swal.noop);
            this.sendMail();
          } else {
            swal({
              title: response.message,
              text: '',
              type: 'error',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#ff5370',
              confirmButtonText: 'Volver',
              // cancelButtonText: 'No'
            }).catch(swal.noop);
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/user/user.component.ts